import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { IonPage, useIonViewWillEnter } from '@ionic/react'
import { restaurantCenter, productMobx, doProductMobx, discountMobx, mallMobx } from '@mobx/mall'
import { ProductDetail } from './component'
import { useHistoryNew, setDocumentTitle } from '@utils'
import NoSearchImg from '@img/no_search_mall.png'
import { useMallRepositoryInit } from '@common/hooks'
import './index.scss'

/** 餐品详情页 */
const Detail: React.FC = (props: any) => {
  const [disableScale, setDisableScale] = useState(false)
  const history = useHistoryNew()

  const handleSet = (flag?: boolean) => {
    const params = props.match?.params
    if (params && flag) {
      if (params.productNo) {
        doProductMobx.pick({ productNo: params.productNo, groupBuyId: params.groupBuyId || '' })
      }
    }
  }
  useMallRepositoryInit()
  useIonViewWillEnter(() => {
    if (!productMobx.products.length) {
      restaurantCenter.init()
    }
    if (!mallMobx.isInited) {
      mallMobx.init()
    }
  }, [history])

  useEffect(() => {
    if (productMobx.viewProducts.length) {
      handleSet(true)
    }
  }, [productMobx.viewProducts, discountMobx.itemDiscountMap])

  useEffect(() => {
    if (doProductMobx.doProduct) {
      setDocumentTitle(doProductMobx.doProduct.name)
    }
  }, [doProductMobx.doProduct])
  const handleCancel = () => {
    history.replace('/mall')
  }
  return (
    <IonPage className='mall-detail-page-modal'>
      {
        mallMobx.isInited ? (
          doProductMobx.doProduct?.no ? <ProductDetail disableScale={disableScale} /> : (
            <div className='empty-info'>
              <img src={NoSearchImg} alt='' className='empty-info-pic' />
              <p className='empty-info-txt'>{i18n.t('mall.productOff')}</p>
              <div className='empty-info-btn' onClick={handleCancel}>{i18n.t('mall.goMall')}</div>
            </div>
          )
        ) : null
      }
    </IonPage>
  )
}

export default observer(Detail)
